export function shuffle<T>(items: readonly T[], random: () => number = Math.random): T[] {
  const result = [...items]
  for (let index = result.length - 1; index > 0; index -= 1) {
    const target = Math.floor(random() * (index + 1))
    const current = result[index]
    const selected = result[target]
    if (current !== undefined && selected !== undefined) {
      result[index] = selected
      result[target] = current
    }
  }
  return result
}
